import { ContainerRef } from '../types';

export const handleClusterHover = ({ object }: any, containerRef: ContainerRef) => {
  if (object && object.cluster && containerRef) {
    containerRef.style.cursor = 'pointer';
  }
};
